<template>
  <nav
    :class="{
      'is-toggled': value
    }"
    class="sidearm-mm-main-nav flex flex-align-center"
  >
    <button
      @click="close"
      type="button"
      aria-label="Close navigation menu"
      class="sidearm-mm-main-nav__close-btn flex inline-flex flex-align-center absolute"
    >
      <span>Close</span>
      <icon size="1.625rem">sf-close-minimal</icon>
    </button>

    <ul
      class="sidearm-mm-main-nav__list sidearm-mm-main-nav__list--level-1 reset relative w-100"
    >
      <li
        v-for="item in nav_items"
        :key="item.hash"
        :class="{
          'is-toggled': item.is_toggled
        }"
        class="sidearm-mm-main-nav__item sidearm-mm-main-nav__item--level-1 relative"
      >
        <button
          v-if="item.items.length"
          @click="toggle_nav_item(item)"
          :tabindex="value ? 0 : -1"
          type="button"
          class="w-100 text-left reset flex flex-align-center"
        >
          <span class="flex-item-1">{{ item.title }}</span>

          <icon v-show="!item.is_toggled">sf-plus-minimal</icon>
          <icon v-show="item.is_toggled">sf-minus-minimal</icon>
        </button>

        <button
          v-else
          :tabindex="value ? 0 : -1"
          @click="navigate_to(item.hash)"
          class="sidearm-mm-main-nav__link sidearm-mm-main-nav__link--level-1 text-decoration-none"
        >
          {{ item.title }}
        </button>

        <ul
          v-if="item.items.length"
          class="sidearm-mm-main-nav__list sidearm-mm-main-nav__list--level-2 relative reset"
        >
          <li
            v-for="sub_item in item.items"
            :key="sub_item.hash"
            class="sidearm-mm-main-nav__item sidearm-mm-main-nav__item--level-2 relative"
          >
            <button
              @click="navigate_to(item.hash, sub_item.hash)"
              :tabindex="item.is_toggled ? 0 : -1"
              class="sidearm-mm-main-nav__link sidearm-mm-main-nav__link--level-2 flex flex-align-center text-decoration-none text-left"
            >
              <span class="flex-item-1 mr-2">{{ sub_item.title }}</span>
              <icon>sf-arrows-thick-right</icon>
            </button>
          </li>
        </ul>
      </li>
      <li
        class="sidearm-mm-main-nav__item sidearm-mm-main-nav__item--level-1 relative"
      >
        <button
          :tabindex="value ? 0 : -1"
          @click="goto($root.continue_url)"
          type="button"
          class="w-100 text-left reset flex flex-align-center"
        >
          {{ "Continue to " + site_url }}
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data: () => ({
    nav_items: [],
    site_url: window.location.host
  }),

  watch: {
    value(newVal) {
      if (newVal) {
        document.body.classList.add("main-nav-is-toggled");
      } else {
        document.body.classList.remove("main-nav-is-toggled");

        this.nav_items.forEach(item => {
          item.is_toggled = false;
        });
      }
    },

    "$root.navigation"(newval) {
      this.nav_items = newval.slice();
    }
  },

  methods: {
    close() {
      this.$emit("input", false);
    },

    navigate_to(section, slide) {
      this.$root.move_via_nav = true;
      this.$root.fullpage_ref.api.silentMoveTo(section, slide);
      this.close();
    },

    toggle_nav_item(item) {
      const value = item.is_toggled;

      this.nav_items.forEach(item => {
        item.is_toggled = false;
      });

      item.is_toggled = !value;
    }
  },

  created() {
    this.nav_items = this.$root.navigation.slice();
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-main-nav {
  background-color: $color-black;
  color: $color-white;
  height: 100vh;
  right: 0;
  padding: $spacer * 5 $spacer * 10 $spacer * 5 $spacer * 15;
  pointer-events: none;
  position: fixed;
  top: 0px;
  transform: translateX(calc(125% + #{grid_percent(60)}));
  transition: 0.35s;
  opacity: 0;
  width: 50%;
  z-index: 1;

  &.is-toggled {
    opacity: 1;
    pointer-events: initial;
    transform: translateX(0%);

    &::before {
      opacity: 1;
      transform: translateX(0);
    }

    .#{$prefix}-main-nav__item--level-1 {
      opacity: 1;
      transition-delay: 0.5s;

      @for $i from 2 through 7 {
        &:nth-child(#{$i}) {
          transition-delay: #{0.5s + 0.2s * ($i - 1)};
        }
      }
    }

    .#{$prefix}-main-nav__list--level-1::before {
      opacity: 1;
      transition-delay: 1.7s;
    }
  }

  &::before {
    background-color: rgba($color-black, 0.85);
    content: "";
    display: block;
    height: 100vh;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    right: 100%;
    top: 0;
    transform: translateX(-100%);
    width: 100vw;
    transition: 0.35s;
  }

  &::after {
    background-blend-mode: darken;
    background-size: cover;
    // background-color: $color-primary;
    // background-image: var(--section-desktop-bg-navigation);
    background-repeat: no-repeat;
    background-position: top center;
    // background: $color-primary url(var(--section-desktop-bg-navigation)) no-repeat top center;
    // border-left: grid_percent(60) solid $color-primary;
    content: "";
    display: block;
    height: 100%;
    left: calc((25% + #{grid_percent(60)}) * -1);
    position: absolute;
    top: 0;
    width: calc(25% + #{grid_percent(60)});
  }

  &__close-btn {
    @include base-reset();

    color: $color-white;
    font-size: 1.125rem;
    font-weight: 400;
    right: $spacer * 4;
    top: $spacer * 4;
  }

  &__list {
    &::before {
      border-left: 1px dashed $color-white;
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
    }
  }

  &__list--level-1 {
    padding-left: $spacer * 5;
    transition: 0.35s;

    &::before {
      height: calc(100% - 1.125rem);
      opacity: 0;
      transition: 0.5s;
    }
  }

  &__item--level-1 {
    opacity: 0;
    transition: 0.5s;

    &:not(:last-child) {
      margin-bottom: $spacer * 5;
    }

    &::before {
      background-color: $color-black;
      border: 0.25rem solid $color-white;
      border-radius: 50%;
      content: "";
      display: block;
      height: 1.125rem;
      left: $spacer * -5;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: 0.35s;
      width: 1.125rem;
    }

    &.is-toggled {
      &::before {
        border: 1px dashed $color-white;
        height: 2rem;
        transition: width 0.35s, height 0.35s;
        width: 2rem;
      }
      .sidearm-mm-main-nav__list--level-2 {
        max-height: calc((1.5rem + #{$spacer * 3}) * 6);
      }
    }
  }

  &__link {
    &--level-1,
    &--level-2 {
      @include base-reset();
    }
    color: $color-white;

    &:hover {
      text-decoration: underline;
    }
  }

  &__list--level-2 {
    max-height: 0px;
    overflow: hidden;
    padding-left: $spacer * 5;
    transition: 0.35s ease-in;
    top: $spacer * 2;

    &::before {
      transform: translate(calc(3 / 8 * 1rem), -50%);
      height: calc(100% - 1rem);
    }
  }

  &__item--level-2 {
    &:not(:last-child) {
      margin-bottom: $spacer * 2;
    }

    &::before {
      background-color: $color-black;
      border: 0.1875rem solid $color-white;
      border-radius: 50%;
      content: "";
      display: block;
      height: 0.75rem;
      left: $spacer * -5;
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      transition: 0.35s;
      width: 0.75rem;
    }
  }

  @media (max-width: 1440px) {
    width: 62.5%;
  }

  @media (max-width: #{$breakpoint-x-large}) {
    width: calc(75% + #{grid_percent(60)});
  }

  @media (max-width: #{$breakpoint-large}) {
    width: 100%;

    &::after {
      display: none;
    }
  }

  @media (max-width: #{$breakpoint-medium-down}) {
    padding: $spacer * 5;
  }

  @media (max-width: #{$breakpoint-small-down}) {
    padding: $spacer * 5 $spacer * 2;

    &__list--level-2 {
      padding-left: 0;
      text-align: left;

      &::before {
        display: none;
      }
    }
  }
}
</style>
